import { useDisclosure, FlexGrid, TypographyHeading, IconButton, ChevronUpIcon, ChevronDownIcon, Anchor, Expand, Skeleton, Styler, useBreakpoints, } from '@honeycomb/ui-core';
import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { HotelDetailsActionType } from '../../../HotelDetails';
import { useHotelDetailsContext } from '../../../HotelDetails/HotelDetails.context';
export function HotelBasketSection({ children, title, icon, relatedSection, collapsible = false, waiting = false, dataId, }) {
    const { resourceStrings: { EDIT_LINK_LABEL }, } = useGlobalContext();
    const { state: { onScrollToSection }, dispatch, } = useHotelDetailsContext();
    const [open, { toggle: handleToggle }] = useDisclosure(false);
    const { largeUp } = useBreakpoints();
    const isMobileLayout = !largeUp;
    const handleClick = React.useCallback(() => {
        if (isMobileLayout) {
            dispatch({
                type: HotelDetailsActionType.SET_MOBILE_DRAWER_OPEN,
                payload: false,
            });
        }
        setTimeout(() => {
            onScrollToSection === null || onScrollToSection === void 0 ? void 0 : onScrollToSection(relatedSection);
        }, 500);
    }, [dispatch, isMobileLayout, onScrollToSection, relatedSection]);
    return (React.createElement(FlexGrid, { component: "article", container: true, disableEqualOverflow: true, alignItems: "flex-start", flexWrap: "nowrap", spacing: 3 },
        React.createElement(FlexGrid, { xs: "hold" }, waiting ? (React.createElement(Skeleton, { variant: "circle", w: 16, h: 16 })) : (React.cloneElement(icon, {
            size: 'xs',
            va: 'top',
            mt: '1px',
        }))),
        React.createElement(FlexGrid, { xs: "fill" },
            React.createElement("div", null,
                React.createElement(FlexGrid, { container: true, disableEqualOverflow: true, alignItems: "flex-start" },
                    React.createElement(FlexGrid, { xs: "fill" },
                        React.createElement(TypographyHeading, { size: "2xs", color: "text.body", component: "h4", "data-id": `${dataId}-header` }, waiting ? React.createElement(Skeleton, { variant: "text", w: 100 }) : title)),
                    React.createElement(FlexGrid, { xs: "hold" }, collapsible ? (React.createElement(IconButton, { size: "2xs", alignEdge: "end", label: open ? 'Hide room details' : 'Show room details', onClick: handleToggle, va: "top", "data-id": `${dataId}-collapsible-icon` }, open ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null))) : (!waiting && (React.createElement(Anchor, { button: true, color: "text.link", size: "xs", weight: "semiBold", display: "flex", onClick: handleClick, "data-id": `${dataId}-edit-icon` }, EDIT_LINK_LABEL))))),
                React.createElement(Styler, { mt: 1 }, collapsible ? (React.createElement(Expand, { in: open },
                    React.createElement("div", { "data-id": `${dataId}-children` }, children))) : (children))))));
}
